var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { MasterService } from '@app/utility/master.service';
import { NotiService } from '@app/noti.service';
var IndexComponent = /** @class */ (function () {
    function IndexComponent(router, apiService, util, sanitizer, MasterService, notiService) {
        this.router = router;
        this.apiService = apiService;
        this.util = util;
        this.sanitizer = sanitizer;
        this.MasterService = MasterService;
        this.notiService = notiService;
        this.isCrisis = false;
        this.top3news = [];
        this.newsList = [];
        this.carouselList = [];
        this.lang = "th";
        this.simulateMenu = {};
        this.contactDpaMenu = {};
        this.faqMenu = {};
        this.loginMenu = {};
        this.trackStatusMenu = {};
        this.inquiryMenu = {};
        this.banklistMenu = {};
    }
    IndexComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            function toggleCaption(index) {
                // $('.carousel-caption-lbl').not('.carousel-caption-lbl' + index.toString()).animate({
                //   opacity: '0'
                // }, 5);
                // //$('.carousel-caption-lbl').fadeOut()
                // $('.carousel-caption-lbl' + index.toString()).animate({
                //   opacity: '1'
                // }, 1200);
            }
            var carouselContainer, slideInterval, _a, crisisConfig, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        this.notiSubscription = this.notiService.message.subscribe(function (_lang) {
                            _this.lang = _lang;
                        });
                        $("div.shadow-box").hover(function () {
                            {
                                $(this).attr("style", "background-color: var(--cust-blue); color: white !important;");
                                var imgSrc = $(this).find("img").attr('src');
                                var h = "-hover";
                                var position = imgSrc.lastIndexOf('.');
                                var newSrc = [imgSrc.slice(0, position), h, imgSrc.slice(position)].join('');
                                $(this).find("img").attr('src', newSrc);
                            }
                        }, function () {
                            {
                                $(this).attr("style", "background-color: white; color: var(--cust-blue) !important;");
                                var imgSrc = $(this).find("img").attr('src');
                                var newSrc = imgSrc.replace("-hover", "");
                                $(this).find("img").attr('src', newSrc);
                            }
                        });
                        carouselContainer = $('.carousel');
                        slideInterval = 5000;
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("master", "configuration")];
                    case 1:
                        _a.config = _d.sent();
                        crisisConfig = this.config.filter(function (c) {
                            return c.dpa_name == "CRISIS FLAG";
                        });
                        if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
                            this.isCrisis = true;
                            //await this.getNews()
                            $(".crisis").show();
                            $(".not-crisis").hide();
                        }
                        else {
                            this.isCrisis = false;
                            $(".not-crisis").show();
                            $(".crisis").hide();
                        }
                        _b = this;
                        return [4 /*yield*/, this.apiService.get("master", "customerPortalMenuSetting")];
                    case 2:
                        _b.menuList = _d.sent();
                        this.simulateMenu = this.getMenuObj("01");
                        this.contactDpaMenu = this.getMenuObj("02");
                        this.faqMenu = this.getMenuObj("03");
                        this.loginMenu = this.getMenuObj("04");
                        this.trackStatusMenu = this.getMenuObj("05");
                        this.inquiryMenu = this.getMenuObj("06");
                        this.banklistMenu = this.getMenuObj("07");
                        if (this.simulateMenu.show) {
                            $(".simulateMenu").show();
                        }
                        else {
                            $(".simulateMenu").hide();
                        }
                        if (this.contactDpaMenu.show) {
                            $(".contactDpaMenu").show();
                        }
                        else {
                            $(".contactDpaMenu").hide();
                        }
                        if (this.faqMenu.show) {
                            $(".faqMenu").show();
                        }
                        else {
                            $(".faqMenu").hide();
                        }
                        if (this.trackStatusMenu.show) {
                            $(".trackStatusMenu").show();
                        }
                        else {
                            $(".trackStatusMenu").hide();
                        }
                        if (this.inquiryMenu.show) {
                            $(".inquiryMenu").show();
                        }
                        else {
                            $(".inquiryMenu").hide();
                        }
                        $(".news-menu").show();
                        _c = this;
                        return [4 /*yield*/, this.MasterService.GetCarousel(this.isCrisis)];
                    case 3:
                        _c.carouselList = _d.sent();
                        carouselContainer.carousel({
                            interval: slideInterval,
                            cycle: true,
                            pause: "false"
                        }).on('slid.bs.carousel', function (e) {
                            var index = $(e.relatedTarget).index();
                            toggleCaption(index);
                        });
                        // $(".carousel-caption-lbl0").animate({
                        //   opacity: '1'
                        // }, 2000);
                        //this.menuList = await this.apiService.get("master", "customerPortalMenuSetting")
                        this.util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    IndexComponent.prototype.ngOnDestroy = function () {
        this.notiSubscription.unsubscribe();
    };
    IndexComponent.prototype.goToNews = function () {
        this.router.navigate(["/mainmenu/allNews"]);
    };
    IndexComponent.prototype.goToContactDpa = function () {
        this.router.navigate(["/mainmenu/contactDPA"]);
    };
    IndexComponent.prototype.goToFaq = function () {
        //this.router.navigate(["/mainmenu/faq"])
        var url = 'https://www.dpa.or.th/';
        window.open(url, "_blank");
    };
    IndexComponent.prototype.goToStatusTracking = function () {
        this.router.navigate(["/mainmenu/statusTracking"]);
    };
    IndexComponent.prototype.goToRefundDeposits = function () {
        this.router.navigate(["/mainmenu/refundDeposits"]);
    };
    IndexComponent.prototype.goToSimulate = function () {
        this.router.navigate(["/mainmenu/simulate"]);
    };
    IndexComponent.prototype.getNews = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        para = "dpa_isdisplayoncustomcrmweb=true&dpa_publishstatus=true&dpa_iscrisis=" + this.isCrisis.toString();
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("crmservice", "news", para)];
                    case 1:
                        _a.newsList = _b.sent();
                        this.newsList.forEach(function (n) {
                            var news = "<a class=\"text-primary mr-5\" target=\"_blank\" href=\"/news/" + n.dpa_newandactivityid + "\">\n          <span class=\"fa fa-newspaper mr-2\"></span>" + n.dpa_name + "\n        </a>";
                            $(".marquee").append(news);
                        });
                        $('.marquee').marquee({
                            duration: 25000,
                            //gap in pixels between the tickers
                            gap: 50,
                            //time in milliseconds before the marquee will start animating
                            delayBeforeStart: 0,
                            //'left' or 'right'
                            direction: 'left',
                            //true or false - should the marquee be duplicated to show an effect of continues flow
                            duplicated: false,
                            pauseOnHover: true
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    IndexComponent.prototype.sanitize = function (str) {
        return this.sanitizer.bypassSecurityTrustStyle(str);
    };
    IndexComponent.prototype.GetLangChanged = function (_lang) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.lang = _lang;
                return [2 /*return*/];
            });
        });
    };
    IndexComponent.prototype.getMenuObj = function (code) {
        if (this.menuList != null && this.menuList.length > 0) {
            var menuObj = this.menuList.filter(function (m) {
                return m.dpa_code == code;
            });
            if (menuObj != null && menuObj.length > 0) {
                if (menuObj[0].dpa_enabledisable == false) {
                    menuObj[0].show = false;
                }
                else if (menuObj[0].dpa_isdisplay == 3) {
                    menuObj[0].show = true;
                }
                else if (menuObj[0].dpa_isdisplay == 1 && !this.isCrisis) {
                    menuObj[0].show = true;
                }
                else if (menuObj[0].dpa_isdisplay == 2 && this.isCrisis) {
                    menuObj[0].show = true;
                }
                else {
                    menuObj[0].show = false;
                }
                return menuObj[0];
            }
            else {
                return {};
            }
        }
        else {
            return {};
        }
    };
    return IndexComponent;
}());
export { IndexComponent };



// WEBPACK FOOTER //
// ./src/app/index/index.component.ts.pre-build-optimizer.js